import {all, fork} from 'redux-saga/effects';
import registerSaga from '@modules/register/redux/saga';
import authSaga from '@modules/login/redux/saga';
import inviteSaga from '@modules/corporate-invite/redux/saga';
import helpDeskSaga from '@modules/helpdesk/redux/saga';
import layoutSaga from '@modules/layouts/redux/saga';
import entitySaga from '@modules/entity/redux/saga';
import corporateSaga from '@modules/corporate/redux/saga';
import calcEngineSaga from '@modules/calculate-engine/redux/saga';
import activitySaga from '@modules/activity/redux/saga';
import reportsSaga from '@modules/reports/redux/saga';
import validatorsSaga from '@modules/validators/redux/saga';
import dashboardSaga from '@modules/dashboard/redux/saga';

import {concat} from 'lodash';

const rootSagas = concat(
  registerSaga,
  authSaga,
  inviteSaga,
  helpDeskSaga,
  layoutSaga,
  entitySaga,
  corporateSaga,
  calcEngineSaga,
  activitySaga,
  reportsSaga,
  validatorsSaga,
  dashboardSaga
);
export default function* rootSaga() {
  yield all(rootSagas.map(fork));
}
